'use client'

import { useSyncExternalStore } from 'react'

const DEFAULT_ORIGIN = 'https://brew.new'

function buildMcpUrl(origin: string): string {
  return `${origin}/api/mcp`
}

const subscribeNoop = () => () => {}

/** Hydration-safe live origin for preview deployments, localhost, and prod. */
function useOrigin(): string {
  return useSyncExternalStore(
    subscribeNoop,
    () => window.location.origin,
    () => DEFAULT_ORIGIN
  )
}

/** The universal MCP endpoint for the deployment currently rendering. */
export function useMcpConnectionUrl(): string {
  return buildMcpUrl(useOrigin())
}
